// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user-info-container {
    background-color: var(--white);
    padding: 20px;
    border-radius: 0.875rem;
    margin: 10px 0 0 10px;
    word-wrap: break-word;
  }

  .main-container {
    display: flex;
  }
  
  .user-info-container h2 {
    margin-bottom: 20px;
    border-bottom: 1px solid var(--bs-chinese-silver);
    padding-bottom: 10px;
  }
  
  .user-info-item {
    margin-bottom: 10px;
    display: flex;
  }
  
  .user-info-label {
    font-weight: bold;
    width: 150px;
  }
  
  .user-info-value {
    flex: 1 1;
  }

  .card-body .alert-info {
    background-color: #335f79
  }


  .card-body .alert-info-white {
    border-color: #335f79;
    border-width: 1px; /* Thin border */
    border-style: solid; /* Ensure the border is visible */
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/componentStyles/CustomerInfo.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;IAC9B,aAAa;IACb,uBAAuB;IACvB,qBAAqB;IACrB,qBAAqB;EACvB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,iDAAiD;IACjD,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,YAAY;EACd;;EAEA;IACE,SAAO;EACT;;EAEA;IACE;EACF;;;EAGA;IACE,qBAAqB;IACrB,iBAAiB,EAAE,gBAAgB;IACnC,mBAAmB,EAAE,iCAAiC;AAC1D","sourcesContent":[".user-info-container {\n    background-color: var(--white);\n    padding: 20px;\n    border-radius: 0.875rem;\n    margin: 10px 0 0 10px;\n    word-wrap: break-word;\n  }\n\n  .main-container {\n    display: flex;\n  }\n  \n  .user-info-container h2 {\n    margin-bottom: 20px;\n    border-bottom: 1px solid var(--bs-chinese-silver);\n    padding-bottom: 10px;\n  }\n  \n  .user-info-item {\n    margin-bottom: 10px;\n    display: flex;\n  }\n  \n  .user-info-label {\n    font-weight: bold;\n    width: 150px;\n  }\n  \n  .user-info-value {\n    flex: 1;\n  }\n\n  .card-body .alert-info {\n    background-color: #335f79\n  }\n\n\n  .card-body .alert-info-white {\n    border-color: #335f79;\n    border-width: 1px; /* Thin border */\n    border-style: solid; /* Ensure the border is visible */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
